// extracted by mini-css-extract-plugin
export var badge = "ShellBottomNav-module--badge--1e345";
export var emptyBadge = "ShellBottomNav-module--emptyBadge--5d41c";
export var pill = "ShellBottomNav-module--pill--0c594";
export var portal = "ShellBottomNav-module--portal--36f45";
export var slot = "ShellBottomNav-module--slot--8e2df";